module.exports = __webpack_public_path__ + "img/2.cb6d19a5.jpg";